import React, { Fragment } from "react";
import MetisMenu from "react-metismenu";
import { useDispatch, useSelector } from "react-redux";
import { MainNav } from "./NavItems";
import { setEnableMobileMenu } from "../../reducers/ThemeOptions";
import { useAuth } from "../../context/AuthContext";

const Nav = () => {
  const dispatch = useDispatch();
const { user } = useAuth();

  const enableMobileMenu = useSelector(
    (state) => state.ThemeOptions.enableMobileMenu
  );

  const toggleMobileSidebar = () => {
    dispatch(setEnableMobileMenu(!enableMobileMenu));
  };

  const isAdmin      = user?.user_type === "admin" || user?.user_type === "superadmin";
  const isSuperAdmin = user?.user_type === "superadmin";

  return (
    <Fragment>
      {MainNav.filter(section => {
        if (section.superAdminOnly) return isSuperAdmin;
        if (section.adminOnly) return isAdmin;
        return true;
      }).map((section) => {
        const items = section.items
          .filter(item => !item.superAdminOnly || isSuperAdmin);

        return (
          <Fragment key={section.heading}>
            <h5 className="app-sidebar__heading">{section.heading}</h5>
            {items.length > 0 && (
              <MetisMenu
                content={items}
                onSelected={toggleMobileSidebar}
                activeLinkFromLocation
                className="vertical-nav-menu"
                iconNamePrefix=""
                classNameStateIcon="pe-7s-angle-down"
              />
            )}
          </Fragment>
        );
      })}
    </Fragment>
  );
};

export default Nav;
